import { render } from "./LbrxLoader.vue?vue&type=template&id=9823d6c4&scoped=true"
import script from "./LbrxLoader.vue?vue&type=script&lang=js"
export * from "./LbrxLoader.vue?vue&type=script&lang=js"

import "./LbrxLoader.vue?vue&type=style&index=0&id=9823d6c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9823d6c4"]])

export default __exports__